//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = "/prototype/accounting/general-ledger/gpr";

export default {
    data: function data() {
        return {
            loading: false,
            period: moment(),
            totals: {}
        };
    },
    mounted: function mounted() {},

    methods: {
        load: function load() {
            var _this = this;

            this.loading = true;
            this.totals = {};
            axios.post(BASE_URL + "/fetch", this.$data).then(function (response) {
                _this.totals = response.data.totals;
                _this.loading = false;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/gpr/GprEntry.vue
// module id = +z3m
// module chunks = 0 1